<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap1"><a id="start">I</a></h1><a id="start">
<h1 class="center">POLITICS AND THE SOCIAL SCENE</h1>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4-chap1.vue?43732d85